{
    "nav__home": "Opportunities",
    "nav__draft_quotes": "Draft Quotes",
    "nav__quotes": "Quotes",
    "nav__orders": "Orders",

    "sidebar__title_customers": "Customers",
    "sidebar__subtitle_oppertunity_count": "Customers with opportunities",
    "sidebar__search_placeholder": "Search for customers, delivery orders, etc.",
    "sidebar__slice_count": "Open",
    "sidebar__slice_business_value": "business value est.",

    "header__business_value": "Estimated total sales volume",
    "header__count_plural": "open",
    "header__count_singular": "open",

    "header__seleceted_count": "selected",

    "actions__select_all": "Select all",
    "actions__email": "Email",
    "actions__task": "Task",
    "actions__quote": "Quote",
    "actions__order": "Order"
}
